<template>
  <!-- Teal "next step" callout (the interaction accent). Field: metadata.next_step. Owner shows as a
       white pill on the right. Renders nothing when there's no next step. -->
  <div v-if="text" class="bg-accent-50 border-l-[3px] border-accent" :class="boxClass">
    <div class="flex items-center justify-between gap-2">
      <span class="uppercase tracking-wide font-bold text-accent inline-flex items-center gap-1" :class="labelClass">
        <font-awesome-icon :icon="['fas', 'arrow-right']" />Next step
      </span>
      <span
        v-if="owner"
        class="shrink-0 inline-flex items-center gap-1 font-medium text-accent bg-white rounded-full px-2 py-0.5"
        :class="labelClass"
      >
        <font-awesome-icon :icon="['fas', 'user']" />{{ owner }}
      </span>
    </div>
    <p class="text-gray-700 leading-relaxed mt-0.5" :class="textClass">{{ text }}</p>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowRight, faUser } from "@fortawesome/free-solid-svg-icons";

library.add(faArrowRight, faUser);

export default {
  name: "ET_NextStep",
  components: { FontAwesomeIcon },
  props: {
    text: { type: String, default: "" },
    owner: { type: String, default: null },
    // sm — compact panes (Map detail); md — roomy panes (Story header, List detail).
    size: { type: String, default: "md" },
  },
  computed: {
    sm() {
      return this.size === "sm";
    },
    boxClass() {
      return this.sm ? "rounded-md px-2 py-1.5" : "rounded-lg px-3 py-2";
    },
    labelClass() {
      return this.sm ? "text-[10px]" : "text-[11px]";
    },
    textClass() {
      return this.sm ? "text-xs" : "text-sm";
    },
  },
};
</script>
